import { StorageKeyConstants } from '@goatsports/shared/util';

export class StorageKeyPortalConstants extends StorageKeyConstants {
  static readonly IS_WORKOUT_LIBRARY = 'is_workout_library';
  static readonly IS_WORKOUT_PREVIEW_MODE = 'is_workout_preview_mode';
  static readonly IS_USER_WORKOUT_PREVIEW_MODE = 'is_user_workout_preview_mode';
  static readonly USER_WORKOUT_EDIT_UID = 'user-workout-edit-uid';
  static readonly ACCORDION_STATES = 'accordion_states';
}
